// Generated by `bazel run //pass_ml/js/autofill:write_sorted_features`. Do not edit.

import { getComputerForFeatures } from "@protontech/autofill/features/feature";
import {
  parentFormFnode,
  field,
  parentFormFeatures,
  formClassification,
  type,
  fieldHaystacks,
  autocomplete,
  parentFormInputIterator,
  isFormRegister,
  isFormRecovery,
  isFormPasswordChange,
  isFormNoop,
  isFormLogin,
  typeValid,
  text,
  label,
  attrs,
  visible,
  prevInput,
  prevField,
  nextField,
  flagHiddenFieldsSideEffect,
  isCC,
  searchField,
  isIdentity,
  fieldFeats,
  fieldText,
  fieldAutocomplete,
  fieldAttrs,
  fieldLabel,
  fieldSearch,
  fieldIdentity,
  fieldCC,
  placeholder,
  fieldAutocompleteOff,
  fieldAutocompleteEmail,
  fieldAttrEmail,
  pattern,
  maxLength,
  fieldFormFeats,
  fieldNext,
  fieldPrev,
  fieldForm,
  fieldRegister,
  fieldLogin,
  fieldExotic,
  fieldPrevInput,
  fieldEmailMatch,
  fieldAttrUsername,
  fieldAutocompleteUsername,
  readonly,
  value,
} from "./abstract.field";
import { exactAttrEmail, textEmail, mfaOutlier, labelEmail, typeEmail, placeholderEmailValue, placeholderEmail } from "./field.email";
import {
  rect,
  numericMode,
  nameMatch,
  idMatch,
  maxLen,
  patternOTP,
  textMFA,
  textAuthenticator,
  textOTP,
  mfaCandidates,
  searchForm,
  outlierLink,
  outlierHeadings,
  outlierForm,
  formMFA,
  formComplexity,
  formAuthenticator,
  similarAfter,
  similarBefore,
  labelOutlier,
  labelOTP,
  labelMFA,
  labelAuthenticator,
  attrOutlier,
  attrOTP,
  attrMFA,
  autocompleteOff,
  autocompleteOTC,
  outlierMaxLength,
  singleInput,
  outlierInputCount,
  outlierSearch,
  siblingOfInterest,
  outlierField,
  otp,
  mfa,
  outlierCandidate,
  outlierEmailMatchRaw,
  outlierAutocomplete,
  outlierEmailMatchScaled,
} from "./field.otp";
import {
  labelReset,
  labelCurrent,
  labelCreate,
  labelConfirm,
  textReset,
  textCurrent,
  textCreate,
  textConfirm,
  prevPwFieldEl,
  passwordOutlier,
  attrReset,
  attrCurrent,
  attrCreate,
  attrConfirm,
  nextPwFieldEl,
  prevPwHaystack,
  prevPwAutocomplete,
  prevPwField,
  outlier as outlier_field_password,
  reset,
  current,
  create,
  confirm,
  nextPwHaystack,
  nextPwAutocomplete,
  nextPwField,
  prevPwNew,
  prevPwCurrent,
  autocompleteGated,
  maybeCurrent,
  maybeNew,
  nextPwConfirm,
  nextPwNew,
  nextPwCurrent,
  autocompleteOTP,
  autocompleteNew,
  autocompleteCurrent,
  fieldRegister_maybeCurrent,
  fieldLogin_maybeNew,
  prevPwCurrent_nextPwNew,
  fieldLogin_autocompleteNew,
  fieldRegister_autocompleteCurrent,
} from "./field.password";
import { textUsername, outlierText, outlierLabel, labelUsername, outlierAttrs, firstFormField, username, outlierEmail, outlier as outlier_field_username, maybeCandidate, firstLoginFormField } from "./field.username";
import { attrMatch, autocompleteUsername, valueCandidate, visibleReadonly, valueUsername, valueTel, valueEmail } from "./field.username-hidden";
import type { fieldFeatures } from "./abstract.field";
import type { emailFeatures } from "./field.email";
import type { otpFeatures } from "./field.otp";
import type { passwordFeatures } from "./field.password";
import type { usernameFeatures } from "./field.username";
import type { usernameHiddenFeatures } from "./field.username-hidden";

export const fieldFeaturesComputer = getComputerForFeatures<typeof fieldFeatures>({
  sorted: [
    parentFormFnode,
    field,
    parentFormFeatures,
    formClassification,
    type,
    fieldHaystacks,
    autocomplete,
    parentFormInputIterator,
    isFormRegister,
    isFormRecovery,
    isFormPasswordChange,
    isFormNoop,
    isFormLogin,
    typeValid,
    text,
    label,
    attrs,
    visible,
    prevInput,
    prevField,
    nextField,
    flagHiddenFieldsSideEffect,
    isCC,
    searchField,
    isIdentity,
  ],
  features: [
    "attrs",
    "autocomplete",
    "isCC",
    "isFormLogin",
    "isFormNoop",
    "isFormPasswordChange",
    "isFormRecovery",
    "isFormRegister",
    "isIdentity",
    "label",
    "nextField",
    "parentFormFeatures",
    "parentFormFnode",
    "prevField",
    "prevInput",
    "searchField",
    "text",
    "visible",
  ],
  private: [],
});

export const emailFeaturesComputer = getComputerForFeatures<typeof emailFeatures>({
  sorted: [
    fieldFeats,
    field,
    fieldText,
    fieldAutocomplete,
    fieldAttrs,
    fieldLabel,
    fieldSearch,
    fieldIdentity,
    fieldCC,
    type,
    placeholder,
    exactAttrEmail,
    textEmail,
    fieldAutocompleteOff,
    fieldAutocompleteEmail,
    mfaOutlier,
    fieldAttrEmail,
    labelEmail,
    typeEmail,
    placeholderEmailValue,
    placeholderEmail,
  ],
  features: ["exactAttrEmail", "attrEmail", "autocompleteEmail", "autocompleteOff", "fieldCC", "fieldIdentity", "isSearchField", "labelEmail", "mfaOutlier", "placeholderEmail", "textEmail", "typeEmail"],
  private: [],
});

export const otpFeaturesComputer = getComputerForFeatures<typeof otpFeatures>({
  sorted: [
    field,
    fieldFeats,
    rect,
    type,
    pattern,
    maxLength,
    placeholder,
    numericMode,
    nameMatch,
    idMatch,
    fieldText,
    fieldFormFeats,
    fieldNext,
    fieldPrev,
    fieldSearch,
    fieldLabel,
    fieldAttrs,
    fieldForm,
    fieldAutocomplete,
    fieldIdentity,
    fieldCC,
    maxLen,
    patternOTP,
    textMFA,
    textAuthenticator,
    textOTP,
    mfaCandidates,
    searchForm,
    outlierLink,
    outlierHeadings,
    outlierForm,
    formMFA,
    formComplexity,
    formAuthenticator,
    similarAfter,
    similarBefore,
    labelOutlier,
    labelOTP,
    labelMFA,
    labelAuthenticator,
    attrOutlier,
    attrOTP,
    attrMFA,
    autocompleteOff,
    autocompleteOTC,
    outlierMaxLength,
    singleInput,
    outlierInputCount,
    outlierSearch,
    siblingOfInterest,
    outlierField,
    otp,
    mfa,
    outlierCandidate,
    outlierEmailMatchRaw,
    outlierAutocomplete,
    outlierEmailMatchScaled,
  ],
  features: [
    "attrMFA",
    "attrOTP",
    "autocompleteOTC",
    "fieldCC",
    "fieldIdentity",
    "formAuthenticator",
    "formComplexity",
    "formMFA",
    "idMatch",
    "labelAuthenticator",
    "labelMFA",
    "labelOTP",
    "nameMatch",
    "numericMode",
    "outlierAutocomplete",
    "outlierEmailMatchScaled",
    "outlierField",
    "outlierForm",
    "outlierHeadings",
    "outlierInputCount",
    "outlierLink",
    "outlierMaxLength",
    "outlierSearch",
    "patternOTP",
    "siblingOfInterest",
    "singleInput",
    "textAuthenticator",
    "textMFA",
  ],
  private: [],
});

export const passwordFeaturesComputer = getComputerForFeatures<typeof passwordFeatures>({
  sorted: [
    fieldFeats,
    fieldLabel,
    fieldText,
    fieldPrev,
    fieldAttrs,
    fieldNext,
    fieldRegister,
    fieldLogin,
    fieldIdentity,
    fieldExotic,
    fieldCC,
    fieldAutocomplete,
    labelReset,
    labelCurrent,
    labelCreate,
    labelConfirm,
    textReset,
    textCurrent,
    textCreate,
    textConfirm,
    prevPwFieldEl,
    passwordOutlier,
    attrReset,
    attrCurrent,
    attrCreate,
    attrConfirm,
    nextPwFieldEl,
    fieldAutocompleteOff,
    prevPwHaystack,
    prevPwAutocomplete,
    prevPwField,
    outlier_field_password,
    reset,
    current,
    create,
    confirm,
    nextPwHaystack,
    nextPwAutocomplete,
    nextPwField,
    prevPwNew,
    prevPwCurrent,
    autocompleteGated,
    maybeCurrent,
    maybeNew,
    nextPwConfirm,
    nextPwNew,
    nextPwCurrent,
    autocompleteOTP,
    autocompleteNew,
    autocompleteCurrent,
    fieldRegister_maybeCurrent,
    fieldLogin_maybeNew,
    prevPwCurrent_nextPwNew,
    fieldLogin_autocompleteNew,
    fieldRegister_autocompleteCurrent,
  ],
  features: [
    "attrConfirm",
    "attrCreate",
    "attrCurrent",
    "attrReset",
    "autocompleteCurrent",
    "autocompleteNew",
    "autocompleteOTP",
    "autocompleteOff",
    "fieldCC",
    "fieldExotic",
    "fieldIdentity",
    "fieldLogin",
    "fieldRegister",
    "labelConfirm",
    "labelCreate",
    "labelCurrent",
    "nextPwConfirm",
    "nextPwCurrent",
    "nextPwField",
    "nextPwNew",
    "passwordOutlier",
    "prevPwCurrent",
    "prevPwField",
    "prevPwNew",
    "textConfirm",
    "textCreate",
    "textCurrent",
    "fieldLogin,autocompleteNew",
    "fieldLogin,maybeNew",
    "fieldRegister,autocompleteCurrent",
    "fieldRegister,maybeCurrent",
    "prevPwCurrent,nextPwNew",
  ],
  private: [],
});

export const usernameFeaturesComputer = getComputerForFeatures<typeof usernameFeatures>({
  sorted: [
    field,
    fieldFeats,
    fieldText,
    fieldLabel,
    fieldAttrs,
    fieldPrevInput,
    fieldSearch,
    fieldIdentity,
    fieldCC,
    fieldAutocomplete,
    textUsername,
    outlierText,
    outlierLabel,
    labelUsername,
    fieldEmailMatch,
    outlierAttrs,
    fieldAttrUsername,
    firstFormField,
    fieldAutocompleteOff,
    fieldAutocompleteEmail,
    fieldAutocompleteUsername,
    username,
    outlierEmail,
    outlier_field_username,
    maybeCandidate,
    firstLoginFormField,
  ],
  features: [
    "attrUsername",
    "autocompleteEmail",
    "autocompleteOff",
    "autocompleteUsername",
    "fieldCC",
    "fieldIdentity",
    "isSearchField",
    "firstLoginFormField",
    "labelUsername",
    "outlierAttrs",
    "outlierEmail",
    "outlierLabel",
    "outlierText",
    "textUsername",
  ],
  private: [],
});

export const usernameHiddenFeaturesComputer = getComputerForFeatures<typeof usernameHiddenFeatures>({
  sorted: [
    fieldFeats,
    field,
    fieldIdentity,
    fieldExotic,
    fieldCC,
    fieldAutocomplete,
    fieldAttrs,
    readonly,
    type,
    value,
    attrMatch,
    fieldAutocompleteEmail,
    autocompleteUsername,
    fieldAttrUsername,
    fieldAttrEmail,
    typeValid,
    valueCandidate,
    visibleReadonly,
    valueUsername,
    valueTel,
    valueEmail,
  ],
  features: ["attrMatch", "autocompleteUsername", "attrEmail", "attrUsername", "autocompleteEmail", "fieldCC", "fieldExotic", "fieldIdentity", "valueEmail", "valueTel", "valueUsername", "visibleReadonly"],
  private: [],
});
